'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resolvers", "referenceObjectType"];
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import ReferenceInputEnumSearch from 'customer-data-reference-ui-components/enum/ReferenceInputEnumSearch';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedAPIDropdown = props => {
  const {
      resolvers,
      referenceObjectType
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(ReferenceInputEnumSearch, Object.assign({}, rest, {
    resolver: resolvers[referenceObjectType]
  }));
};
const getResolvers = ConnectReferenceResolvers(resolvers => ({
  resolvers
}));
export default getResolvers(ConnectedAPIDropdown);